// ── Definizione di tutte le azioni mappabili ──────────────────────────────────

export const BINDABLE_ACTIONS = [
  // Atleta
  { id: 'athlete_blue',       label: 'Atleta Blu',            group: 'Atleta' },
  { id: 'athlete_red',        label: 'Atleta Rosso',          group: 'Atleta' },

  // Tipo azione
  { id: 'type_attack',        label: 'Attacco',               group: 'Tipo azione' },
  { id: 'type_defense',       label: 'Difesa',                group: 'Tipo azione' },
  { id: 'type_counter',       label: 'Contrattacco',          group: 'Tipo azione' },
  { id: 'type_counter_ant',   label: 'Contro anticipo',       group: 'Tipo azione' },
  { id: 'type_counter_int',   label: 'Contro incastro',       group: 'Tipo azione' },
  { id: 'type_counter_2nd',   label: 'C. 2° tempo',           group: 'Tipo azione' },

  // Preset tecnica+esito
  { id: 'preset_1',           label: 'Preset 1 (Pugno corpo punto)', group: 'Preset' },
  { id: 'preset_2',           label: 'Preset 2 (Corpo punto)',       group: 'Preset' },
  { id: 'preset_3',           label: 'Preset 3 (Testa punto)',       group: 'Preset' },
  { id: 'preset_4',           label: 'Preset 4 (Corpo rot. punto)',  group: 'Preset' },
  { id: 'preset_6',           label: 'Preset 6 (Testa rot. punto)',  group: 'Preset' },

  // Esito
  { id: 'outcome_point',      label: 'Esito: Punto',          group: 'Esito' },
  { id: 'outcome_touch',      label: 'Esito: Tocco',          group: 'Esito' },
  { id: 'outcome_miss',       label: 'Esito: Miss',           group: 'Esito' },

  // Bersaglio
  { id: 'target_body',        label: 'Bersaglio: Corpo',      group: 'Bersaglio' },
  { id: 'target_head',        label: 'Bersaglio: Testa',      group: 'Bersaglio' },

  // Biomeccanica
  { id: 'leg_left',           label: 'Gamba sinistra',        group: 'Biomeccanica' },
  { id: 'leg_right',          label: 'Gamba destra',          group: 'Biomeccanica' },
  { id: 'guard_closed',       label: 'Guardia chiusa',        group: 'Biomeccanica' },
  { id: 'guard_open',         label: 'Guardia aperta',        group: 'Biomeccanica' },
  { id: 'distance_clinch',    label: 'Distanza: Clinch',      group: 'Biomeccanica' },
  { id: 'tech_bonus',         label: 'Bonus rotazione',       group: 'Biomeccanica' },

  // Tecniche
  { id: 'tech_Bn',    label: 'Bandal chagi',       group: 'Tecniche' },
  { id: 'tech_Dl',    label: 'Dollyo chagi',        group: 'Tecniche' },
  { id: 'tech_Nr',    label: 'Neryo chagi',         group: 'Tecniche' },
  { id: 'tech_Pk',    label: 'Push Kick',           group: 'Tecniche' },
  { id: 'tech_Dw',    label: 'Dwit chagi',          group: 'Tecniche' },
  { id: 'tech_Md',    label: 'Momdollyo chagi',     group: 'Tecniche' },
  { id: 'tech_Pugno', label: 'Pugno',               group: 'Tecniche' },
  { id: 'tech_2Bn',   label: 'Doppio bandal',       group: 'Tecniche' },
  { id: 'tech_360Bn', label: '360 Bandal',          group: 'Tecniche' },
  { id: 'tech_360Dl', label: '360 Dollyo',          group: 'Tecniche' },
  { id: 'tech_Gr',    label: 'Gerogi',              group: 'Tecniche' },
  { id: 'tech_Clsh',  label: 'Clash',               group: 'Tecniche' },

  // Varianti tecnica (shortcut preimpostati, non in lista tecniche generali)
  { id: 'tech_Bna',   label: 'Bn gamba anteriore',  group: 'Varianti' },
  { id: 'tech_Dla',   label: 'Dl gamba anteriore',  group: 'Varianti' },
  { id: 'tech_Nra',   label: 'Nr gamba anteriore',  group: 'Varianti' },
  { id: 'tech_2Bnf',  label: '2Bn in volo',         group: 'Varianti' },

  // Comandi
  { id: 'sequence_toggle',    label: 'Toggle sequenza',       group: 'Comandi' },
  { id: 'confirm',            label: 'Conferma',              group: 'Comandi' },
  { id: 'cancel',             label: 'Annulla',               group: 'Comandi' },

  // Video
  { id: 'video_play_pause',   label: 'Video: Play / Pausa',   group: 'Video' },
  { id: 'video_seek_back',    label: 'Video: Indietro 1s',    group: 'Video' },
  { id: 'video_seek_fwd',     label: 'Video: Avanti 1s',      group: 'Video' },
  { id: 'video_frame_back',   label: 'Video: Frame indietro', group: 'Video' },
  { id: 'video_frame_fwd',    label: 'Video: Frame avanti',   group: 'Video' },
];

// ── Utility: converti e.code in etichetta leggibile ───────────────────────────
export function codeToLabel(code) {
  if (!code) return '—';
  if (code.startsWith('Key'))   return code.slice(3);          // 'KeyA' → 'A'
  if (code.startsWith('Digit')) return code.slice(5);          // 'Digit1' → '1'
  const MAP = {
    Backquote: '`',   Minus: '-',     Equal: '=',      Backspace: '⌫',
    BracketLeft: '[', BracketRight: ']', Backslash: '\\',
    Semicolon: ';',   Quote: "'",
    Comma: ',',       Period: '.',     Slash: '/',
    IntlBackslash: '<>',
    Space: 'Space',   Tab: 'Tab',      Enter: 'Enter',  Escape: 'Esc',
    CapsLock: 'Caps',
    ShiftLeft: 'Shift', ShiftRight: 'Shift',
    ControlLeft: 'Ctrl', ControlRight: 'Ctrl',
    AltLeft: 'Alt',   AltRight: 'Alt',
    MetaLeft: 'Cmd',  MetaRight: 'Cmd',
    F1:'F1', F2:'F2', F3:'F3', F4:'F4', F5:'F5', F6:'F6',
    F7:'F7', F8:'F8', F9:'F9', F10:'F10', F11:'F11', F12:'F12',
    Insert:'Ins', Delete:'Del', Home:'Home', End:'End',
    PageUp:'PgUp', PageDown:'PgDn',
    ArrowUp:'↑', ArrowDown:'↓', ArrowLeft:'←', ArrowRight:'→',
    PrintScreen:'PrtSc', ScrollLock:'ScrLk', Pause:'Pause',
  };
  return MAP[code] || code;
}

// ── Migrazione: converte vecchi binding e.key → e.code ────────────────────────
// I binding salvati prima del refactor usano e.key (es. 'b', '+', 'Enter').
// Questa funzione li converte al formato code (es. 'KeyB', 'Equal', 'Enter').

const CODE_SET = new Set([
  'Backquote','Digit0','Digit1','Digit2','Digit3','Digit4','Digit5',
  'Digit6','Digit7','Digit8','Digit9','Minus','Equal','Backspace',
  'Tab','KeyQ','KeyW','KeyE','KeyR','KeyT','KeyY','KeyU','KeyI','KeyO','KeyP',
  'BracketLeft','BracketRight','Backslash',
  'CapsLock','KeyA','KeyS','KeyD','KeyF','KeyG','KeyH','KeyJ','KeyK','KeyL',
  'Semicolon','Quote','Enter',
  'ShiftLeft','IntlBackslash','KeyZ','KeyX','KeyC','KeyV','KeyB','KeyN','KeyM',
  'Comma','Period','Slash','ShiftRight',
  'ControlLeft','AltLeft','MetaLeft','Space','MetaRight','AltRight','ControlRight',
  'Escape','F1','F2','F3','F4','F5','F6','F7','F8','F9','F10','F11','F12',
  'Insert','Home','PageUp','Delete','End','PageDown',
  'ArrowUp','ArrowDown','ArrowLeft','ArrowRight',
  'PrintScreen','ScrollLock','Pause',
]);

function isCode(value) {
  return CODE_SET.has(value);
}

function migrateKeyToCode(key) {
  if (!key) return '';
  if (isCode(key)) return key;  // già in formato code
  if (key.length === 1) {
    const lo = key.toLowerCase();
    if (lo >= 'a' && lo <= 'z') return 'Key' + lo.toUpperCase();
    if (lo >= '0' && lo <= '9') return 'Digit' + lo;
    const charMap = {
      '`': 'Backquote', '-': 'Minus',  '=': 'Equal',   '+': 'Equal',
      '[': 'BracketLeft', ']': 'BracketRight', '\\': 'Backslash',
      ';': 'Semicolon', "'": 'Quote',
      ',': 'Comma', '.': 'Period', '/': 'Slash',
      ' ': 'Space',
    };
    return charMap[key] ?? key;
  }
  // Valori speciali multi-char di e.key
  const keyMap = {
    Enter: 'Enter', Escape: 'Escape', Tab: 'Tab', Backspace: 'Backspace',
    CapsLock: 'CapsLock',
    Shift: 'ShiftLeft', ShiftRight: 'ShiftRight',
    Control: 'ControlLeft', ControlRight: 'ControlRight',
    Alt: 'AltLeft', AltRight: 'AltRight',
    Meta: 'MetaLeft', MetaRight: 'MetaRight',
    ArrowUp: 'ArrowUp', ArrowDown: 'ArrowDown',
    ArrowLeft: 'ArrowLeft', ArrowRight: 'ArrowRight',
    Insert: 'Insert', Delete: 'Delete', Home: 'Home', End: 'End',
    PageUp: 'PageUp', PageDown: 'PageDown',
    F1:'F1', F2:'F2', F3:'F3', F4:'F4', F5:'F5', F6:'F6',
    F7:'F7', F8:'F8', F9:'F9', F10:'F10', F11:'F11', F12:'F12',
  };
  return keyMap[key] ?? key;
}

// ── Default Set 2 — valori in e.code (posizione fisica) ──────────────────────
export const DEFAULT_SET2 = {
  athlete_blue:       'KeyB',
  athlete_red:        'KeyR',
  type_attack:        'KeyA',
  type_defense:       'KeyD',
  type_counter:       'KeyC',
  type_counter_ant:   'KeyQ',
  type_counter_int:   'KeyW',
  type_counter_2nd:   'KeyE',
  preset_1:           'Digit1',
  preset_2:           'Digit2',
  preset_3:           'Digit3',
  preset_4:           'Digit4',
  preset_6:           'Digit6',
  outcome_point:      'KeyP',
  outcome_touch:      'KeyT',
  outcome_miss:       'KeyM',
  target_body:        'KeyO',
  target_head:        'KeyI',
  leg_left:           'KeyZ',
  leg_right:          'KeyX',
  guard_closed:       'KeyF',
  guard_open:         'KeyV',
  distance_clinch:    'KeyH',
  tech_bonus:         'KeyU',
  tech_Bn:            '',
  tech_Dl:            '',
  tech_Nr:            '',
  tech_Pk:            '',
  tech_Dw:            '',
  tech_Md:            '',
  tech_Pugno:         '',
  tech_2Bn:           '',
  tech_360Bn:         '',
  tech_360Dl:         '',
  tech_Gr:            '',
  tech_Clsh:          '',
  tech_Bna:           '',
  tech_Dla:           '',
  tech_Nra:           '',
  tech_2Bnf:          '',
  sequence_toggle:    'Equal',   // tasto fisico '=' / '+' (dipende dal layout OS)
  confirm:            'Enter',
  cancel:             'Escape',

  // Video
  video_play_pause:   'Space',
  video_seek_back:    'ArrowLeft',
  video_seek_fwd:     'ArrowRight',
  video_frame_back:   'Comma',
  video_frame_fwd:    'Period',
};

const STORAGE_KEY = 'tkd_keybindings_set2';

export function loadSet2Bindings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const saved = JSON.parse(raw);
      // Migra eventuali valori in formato vecchio (e.key) → e.code
      const migrated = {};
      for (const [id, val] of Object.entries(saved)) {
        migrated[id] = migrateKeyToCode(val);
      }
      return { ...DEFAULT_SET2, ...migrated };
    }
  } catch {}
  return { ...DEFAULT_SET2 };
}

export function saveSet2Bindings(bindings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(bindings));
  } catch {}
}

export function resetSet2Bindings() {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
  return { ...DEFAULT_SET2 };
}

// Mappa inversa: dato un e.code → id azione
export function buildKeyMap(bindings) {
  const map = {};
  for (const [actionId, code] of Object.entries(bindings)) {
    if (code) map[code] = actionId;
  }
  return map;
}
